import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const adminLinks = [
  { label: "Dashboard", to: "/admin/dashboard" },
  { label: "Catalogue Pièces", to: "/admin/catalog" },
  { label: "Validation Comptes", to: "/admin/user-validation" },
  { label: "Créer un compte", to: "/admin/create-account" },
  { label: "Télématique", to: "/admin/telematics" },
  { label: "Sinistres", to: "/admin/crashes" },
  { label: "AI Part Validations", to: "/admin/part-validations" },
  { label: "Visibilite fonctions", to: "/admin/feature-flags" },
  { label: "Features", to: "/admin/features" },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen flex bg-gray-950">
      <aside className="w-64 p-6 bg-gray-900 text-cyan-200 border-r border-gray-800">
        <h2 className="text-2xl font-bold mb-6">1Parc Admin</h2>
        <nav className="flex flex-col gap-3">
          {adminLinks.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                "px-3 py-2 rounded " +
                (isActive
                  ? "bg-cyan-900 text-cyan-300"
                  : "hover:bg-cyan-950")
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 p-8 bg-gray-950 text-gray-100">
        <Outlet />
      </main>
    </div>
  );
}
